import request from "@/utils/request";

/*=======================教师发展========================*/

// 查询各维度教师统计数量
export const  teacherData =(query) =>{
    return request({
        url: "/businessservice/schoolDashboard/teacher/teaData",
        method:"get",
        params: query
    })
}

// 查询教师概况
export const  teacherOverview =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/teacher/teaOverview",
        method:"post",
        data: data
    })
}

// 查询教师年龄分布
export const  teacherAge =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/teacher/teaAge",
        method:"post",
        data: data
    })
}

// 查询教师教龄分布
export const  teacherTeachAge =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/teacher/teaTeachAge",
        method:"post",
        data: data
    })
}

// 查询教师学科分布
export const  teacherSubject =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/teacher/teaSubject",
        method:"post",
        data: data
    })
}

// 查询教师学科新老教师分布
export const  teacherTeachAgeSubject =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/teacher/teaTeachAgeSubject",
        method:"post",
        data: data
    })
}

// 录入或更新教师职位分布数据
export const  createTeacherPost =(data) =>{
    return request({
        url: "/businessservice/teacherPost/createOrUpdate",
        method:"post",
        data: data
    })
}

// 查询各维度教师统计数量
export const  teacherPost =(query) =>{
    return request({
        url: "/businessservice/teacherPost/postInfo",
        method:"get",
        params: query
    })
}

/*=======================协同备课========================*/

// 查询学校协同备课统计数量
export const  lessonData =(query) =>{
    return request({
        url: "/businessservice/schoolDashboard/lesson/data",
        method:"get",
        params: query
    })
}

// 查询学校协同备课方式统计数量
export const  lessonTypeData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/lesson/lessonType",
        method:"post",
        data: data
    })
}

// 查询学校协同备课学科分布
export const  lessonSubjectData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/lesson/lessonSubject",
        method:"post",
        data: data
    })
}

// 查询学校协同备课人数分布
export const  lessonNumData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/lesson/lessonNum",
        method:"post",
        data: data
    })
}

// 查询学校协同备课时间分布
export const  lessonYearData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/lesson/lessonYear",
        method:"post",
        data: data
    })
}

// 查询学校协同备课学科教龄分布
export const  lessonTeachAgeData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/lesson/lessonTeachAge",
        method:"post",
        data: data
    })
}

// 查询学校协同备课年龄分布
export const  lessonAgeData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/lesson/lessonAge",
        method:"post",
        data: data
    })
}

/*=======================听评课========================*/

// 查询学校听评课统计数量
export const  evaData =(query) =>{
    return request({
        url: "/businessservice/schoolDashboard/eva/data",
        method:"get",
        params: query
    })
}

// 查询学校听评课方式统计数量
export const  evaTypeData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/eva/lessonType",
        method:"post",
        data: data
    })
}

// 查询学校听评课学科分布
export const  evaSubjectData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/eva/lessonSubject",
        method:"post",
        data: data
    })
}

// 查询学校听评课人数分布
export const  evaNumData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/eva/lessonNum",
        method:"post",
        data: data
    })
}

// 查询学校听评课时间分布
export const  evaYearData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/eva/lessonYear",
        method:"post",
        data: data
    })
}

// 查询学校听评课学科教龄分布
export const  evaTeachAgeData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/eva/lessonTeachAge",
        method:"post",
        data: data
    })
}

// 查询学校听评课年龄分布
export const  evaAgeData =(data) =>{
    return request({
        url: "/businessservice/schoolDashboard/eva/lessonAge",
        method:"post",
        data: data
    })
}